import React from 'react';
export type DateRange = 'Today' | 'WTD' | '7D' | 'MTD' | '30D';
export interface FilterState {
  dateRange: DateRange;
  team: string;
  showFlaggedOnly: boolean;
}
export function isCountMode(dateRange: DateRange): boolean {
  return dateRange === 'Today' || dateRange === 'WTD';
}
interface DashboardHeaderProps {
  filters: FilterState;
  onFilterChange: (filters: FilterState) => void;
  teams: string[];
}
export function DashboardHeader({
  filters,
  onFilterChange,
  teams
}: DashboardHeaderProps) {
  return <div className="bg-white border-b border-gray-200 py-4 px-6 flex flex-col md:flex-row md:items-center justify-between gap-4 mb-6" data-id="element-60">
      <div data-id="element-61">
        <h1 className="text-2xl font-bold text-gray-900" data-id="element-62">
          Sales Manager Console
        </h1>
        <p className="text-sm text-gray-500 mt-1" data-id="element-63">
          Monitor Loan Officer performance and pipeline health
        </p>
      </div>

      <div className="flex flex-wrap items-center gap-4" data-id="element-64">
        {/* Date Range Selector */}
        <div className="flex bg-gray-100 p-1 rounded-lg" data-id="element-65">
          {(['Today', 'WTD', '7D', 'MTD', '30D'] as const).map(range => <button key={range} onClick={() => onFilterChange({
          ...filters,
          dateRange: range
        })} className={`px-3 py-1.5 text-sm font-medium rounded-md transition-colors ${filters.dateRange === range ? 'bg-white text-gray-900 shadow-sm' : 'text-gray-500 hover:text-gray-700'}`} data-id="element-66">
              {range}
            </button>)}
        </div>

        {/* Team Filter */}
        <select value={filters.team} onChange={e => onFilterChange({
        ...filters,
        team: e.target.value
      })} className="bg-white border border-gray-300 text-gray-700 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block p-2 outline-none" data-id="element-67">
          <option value="All" data-id="element-68">All Teams</option>
          {teams.map(team => <option key={team} value={team} data-id="element-69">
              {team}
            </option>)}
        </select>

        {/* Show Flagged Only Toggle */}
        <label className="flex items-center cursor-pointer" data-id="element-70">
          <div className="relative" data-id="element-71">
            <input type="checkbox" className="sr-only" checked={filters.showFlaggedOnly} onChange={e => onFilterChange({
            ...filters,
            showFlaggedOnly: e.target.checked
          })} data-id="element-72" />
            <div className={`block w-10 h-6 rounded-full transition-colors ${filters.showFlaggedOnly ? 'bg-red-500' : 'bg-gray-300'}`} data-id="element-73"></div>
            <div className={`dot absolute left-1 top-1 bg-white w-4 h-4 rounded-full transition-transform ${filters.showFlaggedOnly ? 'transform translate-x-4' : ''}`} data-id="element-74"></div>
          </div>
          <span className="ml-3 text-sm font-medium text-gray-700" data-id="element-75">
            Flagged Only
          </span>
        </label>
      </div>
    </div>;
}